<template>
  <div>
    <b-card>
      <!-- en TODO of ActivityDetailBadges -->
      <b-card-title class="mb-75">
        {{ activity.name }}
        <b-spinner
          small
          class="float-right"
          variant="primary"
          v-if="activity.meta.isUpdating"
        />
      </b-card-title>
      <div class="border rounded mb-3 px-4 py-3">
        <b-card-text
          :inner-html.prop="activity.description | markdown"
        />
      </div>
      <div class="clearfix">
        <ActivityAliveBadge
          class="float-right"
          show-date
          :expired-at="activity.expiredAt"
          :created-at="activity.createdAt"
        />
      </div>
      <div class="text-right mt-2 font-weight-bold">
        {{ activity.targetUserName }}
      </div>
    </b-card>
    <ActivityComments :activity-id="activity.id" />
    <ActivityTimeline :activity-id="activity.id" />
  </div>
</template>
<script>

import ActivityComments from '@/febos/global/kanban/components/ActivityComments';
import ActivityTimeline from '@/febos/global/kanban/components/ActivityTimeline';
import ActivityAliveBadge from '@/febos/global/kanban/components/ActivityAliveBadge';

export default {
  components: {
    ActivityAliveBadge,
    ActivityTimeline,
    ActivityComments
  },
  props: {
    activity: Object
  }
};

</script>
